<template>
  <div class="tel-fab">
    <div class="tel-fab-pc">
      <div>{{ telNumber }}<p>{{ availableMessage }}</p></div>
    </div>
    <div class="tel-fab-mobile">
      <div class="tel-fab-badge">{{ availableMessage }}</div>
      <a :href="'tel:'+telNumber">전화문의</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tel-fab',
    props: {
      telNumber: {
        type: String,
        default: function () {
          return ''
        }
      },
      availableMessage: {
        type: String,
        default: function () {
          return '상담시간: 평일 9시 ~ 18시'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tel-fab {
    &-pc {
      position: fixed;
      left: 24px;
      bottom: 24px;
      padding: 24px 0;
      width: 280px;
      height: 97px;
      opacity: 0.8;
      border-radius: 48.5px;
      box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.3);
      background-color: #868e96;
      text-align: center;
      z-index: 15;
      font-size: 22px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.18;
      letter-spacing: -1.1px;
      color: #ffffff;

      &:hover {
        opacity: 1;
      }

      p {
        margin: 8px 0 0 0;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: -0.8px;
        color: #dee2e6;
      }

      @media (max-width: 767px) {
        display: none;
      }
    }

    &-mobile {
      display: none;

      .tel-fab-badge {
        position: fixed;
        left: calc(50% - 64px);
        bottom: 52px;
        width: auto;
        height: auto;
        padding: 3px 8px;
        opacity: .8;
        box-shadow: 0 3px 8px 0 rgba(0,0,0,.3);
        background-color: #868e96;
        text-align: center;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.18;
        letter-spacing: -1.1px;
        font-size: 12px;
        font-weight: 400;
        border-radius: 10px;
        color: $hzc-white;
        z-index: 15;

        &:hover {
          opacity: 1;
        }
      }

      a {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 16px 0;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.14;
        letter-spacing: -0.8px;
        text-align: center;
        color: #ffffff;
        background-color: #5f78a4;
        text-decoration: none;
        z-index: 15;

        &:active {
          background-color: darken(#5f78a4, 10%);
        }
      }

      @media (max-width: 767px) {
        display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TelFab.vue